module.exports = __webpack_public_path__ + "img/sellerreg.5182d339.png";